import { Heart, HeartSelected } from '@components/icons'
import s from '@pagestyles/PDP.module.scss'
import { TFunction } from 'next-i18next/pages'
import { WishlistButtonContentProps } from '@corratech/pylot-wishlist/src/AddToWishlist/AddToWishlist'

export const createWishlistButtonContent = (t: TFunction) => {
    return function WishlistButtonContent({
        isProductInWishlist
    }: WishlistButtonContentProps) {
        return (
            <div className={s['add-to-wishlist-btn']}>
                <div className={s['heart-container']}>
                    {isProductInWishlist ? <HeartSelected /> : <Heart />}
                </div>
                <p className={s['label']}>
                    {isProductInWishlist
                        ? t('wishlist||wishlist|Added to wishlist')
                        : t('wishlist||wishlist|Add to wishlist')}
                </p>
            </div>
        )
    }
}
